import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import IframeLayout from '../components/iframe-layout/iframe-layout';
import IframePromo from '../components/iframe-promo/iframe-promo';

const SSCityServicesPromo = ({ data }) => {
  // Pull out the relevant content from the data.
  // Make sure at least one result is returned before rendering the layout.
  const content = data.allTaxonomyTermPromotion.edges[0].node.relationships
    ? data.allTaxonomyTermPromotion.edges[0].node.relationships
      .field_promoted_content[0]
    : null;

  return (
    <React.Fragment>
      {content && (
        <IframeLayout>
          <IframePromo content={content} />
        </IframeLayout>
      )}
    </React.Fragment>
  );
};

SSCityServicesPromo.propTypes = {
  data: PropTypes.object
};

export default SSCityServicesPromo;

export const query = graphql`
  query SSCityServices {
    allTaxonomyTermPromotion(filter: { drupal_id: { eq: "5fcd13c3-9c48-449e-bf68-f8db14ccdf2d" } }) {
      edges {
        node {
          name
          relationships {
            field_promoted_content {
              ...IframeEvent
              ...IframeNews
              ...IframePlace
            }
          }
        }
      }
    }
  }
`;
